import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RequestService} from '../../../handlers/request/request.service';

import {ShippingReq} from '../../models/marketplace-courier/requests/shipping-req';
import {ShippingRes} from '../../models/marketplace-courier/responses/shipping-res';
import {courierApi} from '../../api/marketplace-courier/shipping.api';
import {marketplaceCourierKey} from 'src/environments/marketplace-courier-api-key';
import { globalEnv } from '../../connection/global/global.env';
import { OrderTrackingResp } from '../../models/marketplace-courier/responses/order-tracking-resp';
import { DaneCodeReq } from '../../models/marketplace-courier/requests/dane-code-req';
@Injectable({
  providedIn: 'root',
})
export class CourierService {
  constructor(private req: RequestService) {}

  get(body: ShippingReq): Observable<ShippingRes> {
    const customerHeader = {'X-API-KEY': marketplaceCourierKey.xApiKey};
    return this.req.post(`${globalEnv.courier}${courierApi.cost}`, body, null, null, true, false, customerHeader);
  }
  getOrder(orderId: number): Observable<OrderTrackingResp> {
    const orderHeader = {'X-API-KEY': marketplaceCourierKey.xApiKeyOrder};
    return this.req.get(`${globalEnv.marketplace_order}${courierApi.order}`, {}, orderId, null, true, false, orderHeader);
  }
  getAddress(params:DaneCodeReq): Observable<string>{
    return this.req.get(`${globalEnv.be2}${courierApi.address}`, params, null, true);
  }
}
